import { render } from "./g-account-username_change.vue?vue&type=template&id=8a7716e6&ts=true"
import script from "./g-account-username_change.vue?vue&type=script&lang=tsx"
export * from "./g-account-username_change.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__